module.exports = __webpack_public_path__ + "static/media/Badge_PngMarquePrivilege_Biotherm_disabled.8fa359db.png";